import React, { useState, useEffect } from "react";
import { Table, message } from "antd";
import SchemesDistrictQuery from "../CommonForm/indexRejPage";
import { getExistedSchemesAplication, queryApplication, queryFormApplication } from "../../../../../auth/services/privateapicalling";
import { useSelector } from "react-redux";
import { formFieldDataP1, formFieldDataP2, formFieldDataP3 } from "../../../../../../core/data/json/DistrictAPMC";
import { useLocation, useNavigate } from "react-router";
import { toast, ToastContainer } from "react-toastify";

const SchemesAuthorityDistrictTable = () => {
  const token = useSelector((state: any) => state.auth.token);
  const userDetail = useSelector((state: any) => state.auth.userDetails);
  const [existData, setExistData] = useState<any | null>(null);
  const [queries, setQueries] = useState([]);
  const [unverifiedFields, setUnverifiedFields] = useState<string[]>([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [commentsubmitted, setCommentSubmitted]=useState(false);
const navigate = useNavigate();
  // Function to find field data from form field arrays
  const findFieldData = (fieldName) => {
    const allFormData = [...(formFieldDataP1 || []), ...(formFieldDataP2 || []), ...(formFieldDataP3 || [])];
    return allFormData.find(field => 
      field?.response && Array.isArray(field.response) && field.response.some(resp => resp?.fieldName === fieldName)
    );
  };

  const roleIdentifier = userDetail.Role.Role_Identifier;
const [resubmittedFields, setResubmittedFields] = useState({
  annexureOne: {},
  annexureTwo: {},
  annexureThree: {}
});

  const location = useLocation()
 

  // Get applicationId and id from location state
  const [applicationId, setApplicationID] = useState(location?.state?.applicationId)
  const [id, setId] = useState(location?.state?.id)

  // Function to extract unverified fields
  const extractUnverifiedFields = (apiData) => {
    const unverified = [];
    
    const annexures = [
      { data: apiData?.annexureOne, name: "annexureOne" },
      { data: apiData?.annexureTwo, name: "annexureTwo" },
      { data: apiData?.annexureThree, name: "annexureThree" }
    ];

    annexures.forEach(({ data: annexureData }) => {
      if (annexureData) {
        Object.keys(annexureData).forEach(fieldName => {
          const fieldData = annexureData[fieldName];
          if(fieldName!=="estimateProjectCost")
       {   if (fieldData?.transaction && Array.isArray(fieldData.transaction)) {
            const lastTransaction = fieldData.transaction[fieldData.transaction.length - 1];
            
            if (lastTransaction?.isVerified === false) {
              unverified.push(fieldName);
            }
          }}
        });
      }
    });

    return unverified;
  };

  //---------------------------------------------------Validations
  const [emptyFields, setEmptyFields] = useState(new Set());
  const [submitAttempted, setSubmitAttempted] = useState(false);

const validateAllComments = () => {
  const emptyFieldKeys = new Set();
  let hasEmptyFields = false;

  queries.forEach(query => {
    if (!query.standardizedComment || query.standardizedComment.trim() === "") {
      emptyFieldKeys.add(query.key);
      hasEmptyFields = true;
    }
  });

  setEmptyFields(emptyFieldKeys);
  setSubmitAttempted(true); // Mark that submit was attempted
  return !hasEmptyFields;
};





  // Function to generate queries from API data
  const generateQueries = (apiData) => {
    const generatedQueries = [];
    let keyCounter = 1;

    const annexures = [
      { data: apiData?.annexureOne, name: "Table 1", type: "annexureOne" },
      { data: apiData?.annexureTwo, name: "Table 2", type: "annexureTwo" },
      { data: apiData?.annexureThree, name: "Table 3", type: "annexureThree" }
    ];

    annexures.forEach(({ data: annexureData, name: annexureName, type: annexureType }) => {
      if (annexureData) {
        Object.keys(annexureData).forEach(fieldName => {
          const fieldData = annexureData[fieldName];

          if (fieldData?.transaction && Array.isArray(fieldData.transaction)) {
            const lastTransaction = fieldData.transaction[fieldData.transaction.length - 1];
if(fieldName!=="estimateProjectCost")
          {  if (lastTransaction?.isVerified === false) {
              const formFieldData = findFieldData(fieldName);

              generatedQueries.push({
                key: keyCounter++,
                annexure: annexureName,
                annexureType: annexureType,
                fieldNumber: formFieldData?.fieldNo || formFieldData?.fieldVal,
                comment: lastTransaction.comment || "No comment provided",
                status: "reject",
                checked: false,
                fieldName: fieldName,
                transactionData: lastTransaction,
                standardizedComment: "" // Initialize with empty string
              });
            }}
          }
        });
      }
    });

    return generatedQueries;
  };

const columns = [
  {
    title: "Annexure",
    dataIndex: "annexure",
    width: 150,
    render: (text: string) => (
      <span className="badge bg-light text-dark border">{text}</span>
    ),
  },
  {
    title: "Field Number",
    dataIndex: "fieldNumber",
    // width: 100,
    ellipsis: true,
    render: (text: string) => (
      <span>{text}</span>
    ),
  },
  {
    title: "Comment",
    dataIndex: "comment",
    render: (text: string) => (
      <div style={{ maxWidth: '300px', wordWrap: 'break-word' }}>
        {text}
      </div>
    ),
  },
  {
    title: "Standardized Comment *",
    dataIndex: "standardizedComment",
    render: (value: any, record: any) => {
      const isEmpty = !value || value.trim() === "";
      const showValidation = submitAttempted && emptyFields.has(record.key);
      
      return (
        <div>
          <textarea 
            placeholder="Write Here..." 
            className={`w-100 rounded ${showValidation ? 'border-danger' : ''}`}
            rows={3}
            value={value || ""}
            onChange={(e) => handleStandardizedCommentChange(record.key, e.target.value)}
            style={{
              borderColor: showValidation ? '#dc3545' : '#ced4da',
              borderWidth: showValidation ? '2px' : '1px'
            }}
          />
          {/* Step 4a: Show validation message directly under the textarea */}
          {showValidation && (
            <div className="mt-1">
              <span className="text-danger small d-flex align-items-center">
                <i className="feather feather-alert-circle me-1"></i>
                Please fill this comment
              </span>
              <span className="text-danger small d-flex align-items-center">
                <i className="feather feather-alert-circle me-1"></i>
                કૃપા કરીને આ ટિપ્પણી ભરો
              </span>
            </div>
          )}
        </div>
      );
    },
  },
];



  // -------------------------------------------------Standardized Comment
const handleStandardizedCommentChange = (key, value) => {
  setQueries(prev => prev.map(query => 
    query.key === key 
      ? { ...query, standardizedComment: value }
      : query
  ));

  // Remove from empty fields if user starts typing
  if (value.trim() !== "") {
    setEmptyFields(prev => {
      const newSet = new Set(prev);
      newSet.delete(key);
      return newSet;
    });
  } else {
    // Add to empty fields if field becomes empty and submit was attempted
    if (submitAttempted) {
      setEmptyFields(prev => new Set(prev).add(key));
    }
  }
};

  const prepareRejectedStandardized = () => {
     return queries
      .filter(query => query.standardizedComment && query.standardizedComment.trim() !== "")
      .map(query => ({
    fieldUpdated: query.fieldName,
    annexureUpdated: query.annexureType,
    newTransaction: {
      transactionBy: userDetail?.Role?.Role_Identifier,
      status:  "pending",
      appStatusLevel:  existData?.appStatusLevel ,
      newValue:  []
    },
    isVerified: false,
    isUpdated:  true,
    comment: query.standardizedComment || ""
  }));

}
const handleSubmitComment = async () => {
    try {
      // Check if there are any queries to validate
      if (queries.length === 0) {
        message.warning("No queries found to submit.");
        return;
      }

      // Validate all standardized comments are filled
      const isValid = validateAllComments();
      
      if (!isValid) {
        message.error({
          content: (
            <div>
              <div>Please fill in all standardized comments before submitting.</div>
              <div>સબમિટ કરતા પહેલા કૃપા કરીને બધી પ્રમાણિત ટિપ્પણીઓ ભરો.</div>
            </div>
          ),
          duration: 5,
          style: { marginTop: '0' }
        });
        
        // Scroll to first empty field
        setTimeout(() => {
          const firstEmptyField = document.querySelector('.border-danger');
          if (firstEmptyField) {
            firstEmptyField.scrollIntoView({ behavior: 'smooth', block: 'center' });
            (firstEmptyField as HTMLElement).focus();
          }
        }, 100);
        
        return;
      }

      setIsSubmitting(true);

      // Prepare payload with all validated comments
      const commentsWithText = queries.filter(query => 
        query.standardizedComment && query.standardizedComment.trim() !== ""
      );


      const payload = {
        // applicationId: String(applicationId),
        couchId:existData?.applicationDataId,
        // status: existData?.buttonName[0]?.status,
        
        applicationType: "scheme",
     fieldsToUpdate:prepareRejectedStandardized()
      };

    

      // Call the API
      const response = await queryFormApplication(payload, token);

      if (response?.dbResult?.ok) {
        message.success({
          content: `Successfully submitted ${commentsWithText.length} standardized comments!`,
          duration: 5
        });
        
        // Reset comments and validation state after successful submission
        // setQueries(prev => prev.map(query => ({
        //   ...query,
        //   standardizedComment: "",
        //   status: "Resolved"
        // })));
        setCommentSubmitted(true);
        
        setEmptyFields(new Set());
        setSubmitAttempted(false);
        
        // Refresh the data
        await getExistedApplication();
        //  navigate("/apmc-forms-application");
      } else {
        message.error("Failed to submit comments. Please try again.");
      }
    } catch (error) {
   
      message.error("An error occurred while submitting comments. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };
  // Function to prepare rejected field names for API
  const prepareRejectedFieldNames = () => {
    return queries
      // .filter(query => query.standardizedComment && query.standardizedComment.trim() !== "")
      .map(query => ({
        annexureType: query.annexureType,
        key: query.fieldName,
        // comment:query.standardizedComment
      }));
  };

  // Function to prepare resubmitted fields for API
  const prepareResubmittedFields = () => {
    const resubmittedFields = {
      annexureOne: {},
      annexureTwo: {},
      annexureThree: {}
    };

    queries
      .filter(query => query.standardizedComment && query.standardizedComment.trim() !== "")
      .forEach(query => {
        if (existData && existData[query.annexureType] && existData[query.annexureType][query.fieldName]) {
          resubmittedFields[query.annexureType][query.fieldName] = existData[query.annexureType][query.fieldName];
        }
      });

    // Remove empty annexures
    Object.keys(resubmittedFields).forEach(key => {
      if (Object.keys(resubmittedFields[key]).length === 0) {
        delete resubmittedFields[key];
      }
    });

    return resubmittedFields;
  };

  // Function to handle comment submission

 const handleFinalSubmit = async (status, appStatusLevel) => {
  try {
    // Check if there are any queries to validate
 if(roleIdentifier === "JC"||roleIdentifier === "SC")
      {   if(!commentsubmitted){
        toast.error("Please resolve all queries or add comment for fields before submitting the form.",{
          position: "top-right",
          autoClose: 3000,
        });
        return
      }}

    // Prepare payload with all validated comments
   

    const payload = {
      applicationId: String(applicationId),
      status: status,
      appStatusLevel: appStatusLevel,
      applicationType: "scheme",
      schemeId: id,
                ...((roleIdentifier === "JC"||roleIdentifier === "SC") && {
    rejectedFieldName:prepareRejectedFieldNames(),
 
  }),
    };

  

    // Call the API
    const response = await queryApplication(payload, token);

    if (response?.success) {
        toast.success(
                 <>
                   Form submitted successfully <br /> ફોર્મ સફળતાપૂર્વક સબમિટ કર્યું
                 </>,
                 {
                   position: "top-right",
                   style: { fontSize: "1.2rem", padding: "16px" },
                 }
               );
       navigate("/rejected-apmc-application");
    
    } else {
     toast.error(
             <>
               Submission failed, please try again <br />
               સબમિશન નિષ્ફળ ગયું, કૃપા કરીને ફરી પ્રયાસ કરો
             </>,
             {
               position: "top-right",
               style: { fontSize: "1.2rem", padding: "16px" },
             }
           );
    }
  } catch (error) {
  
    // message.error("An error occurred while submitting comments. Please try again.");
  } finally {
    // setIsSubmitting(false);
  }
};

// const renderSubmitButton = () => {
//   const hasEmptyFields = emptyFields.size > 0;
//   const totalQueries = queries.length;
//   const filledQueries = queries.filter(q => q.standardizedComment && q.standardizedComment.trim() !== "").length;

//   return (
//     <div className="d-flex justify-content-end align-items-center">
//       <div className="me-3">
//         <small className="text-muted">
//           Progress: {filledQueries}/{totalQueries} comments filled
//         </small>
//         {hasEmptyFields && (
//           <div>
//             <small className="text-danger">
//               <i className="feather feather-alert-triangle"></i> {emptyFields.size} field(s) require attention
//             </small>
//           </div>
//         )}
//       </div>
//       <button
//         className={`btn mt-2 ${hasEmptyFields ? 'btn-secondary' : 'btn-info'}`}
//         onClick={handleSubmitComments}
//         disabled={isSubmitting || hasEmptyFields}
//         title={hasEmptyFields ? "Please fill all standardized comments" : "Submit all comments"}
//       >
//         {isSubmitting ? (
//           <>
//             <span className="spinner-border spinner-border-sm me-2" role="status"></span>
//             Submitting...
//           </>
//         ) : (
//           `Submit Comments (${filledQueries}/${totalQueries})`
//         )}
//       </button>
//     </div>
//   );
// };


// const renderValidationSummary = () => {
//   const totalQueries = queries.length;
//   const filledQueries = queries.filter(q => q.standardizedComment && q.standardizedComment.trim() !== "").length;
//   const emptyCount = totalQueries - filledQueries;

//   if (totalQueries === 0) return null;

//   return (
//     <div className="alert alert-info mb-3">
//       <div className="d-flex justify-content-between align-items-center">
//         <div>
//           <strong>Validation Summary:</strong>
//           <span className="ms-2">
//             {filledQueries === totalQueries ? (
//               <span className="text-success">
//                 <i className="feather feather-check-circle"></i> All comments completed
//               </span>
//             ) : (
//               <span className="text-warning">
//                 <i className="feather feather-clock"></i> {emptyCount} comment(s) pending
//               </span>
//             )}
//           </span>
//         </div>
//         <div className="progress" style={{ width: '200px', height: '20px' }}>
//           <div 
//             className={`progress-bar ${filledQueries === totalQueries ? 'bg-success' : 'bg-warning'}`}
//             style={{ width: `${(filledQueries / totalQueries) * 100}%` }}
//           >
//             {Math.round((filledQueries / totalQueries) * 100)}%
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

  const pendingCount = queries.filter((q) => q.status === "reject").length;
  const resolvedCount = queries.filter((q) => q.status === "Resolved").length;
  const totalCount = queries.length;



  const getExistedApplication = async () => {
    try {

      const response = await getExistedSchemesAplication(token, applicationId, id);
      

      if (response?.success) {
        
        setExistData(response?.data);
        
     
        
        // Generate queries and extract unverified fields
        const generatedQueries = generateQueries(response.data);
        const unverified = extractUnverifiedFields(response.data);
        
        setQueries(generatedQueries);
        setUnverifiedFields(unverified);
        
      
      }
    } catch (error) {
     
    }
  };

  useEffect(() => {
    if (token && applicationId && id) {
      getExistedApplication();
    }
  }, [token, applicationId, id]);

  return (
    <>
    <div className="page-wrapper">
      <div>
        <h2 className="m-3">Application Id - {applicationId}</h2>
      </div>

      {(roleIdentifier=="JC" || roleIdentifier=="SC")? <div className="m-3 mx-5 card p-3">
        <div className="d-flex justify-content-between">
          <div className="mb-2">
            <h3 className="mb-1">
              <i className="feather feather-message-square text-info"></i>{" "}
              Senior Authority Queries & Comments
            </h3>
            <p className="text-muted">Resolved the given queries</p>
          </div>

          <div className="mb-3">
            <span className="text-warning">●</span> Pending: {pendingCount}
            <span className="text-success ms-3">●</span> Resolved: {resolvedCount}
            <span className="text-primary ms-3">●</span> Total: {totalCount}
          </div>
        </div>

        {queries.length > 0 ? (
          <Table 
            columns={columns}
            dataSource={queries} 
            bordered 
            pagination={false} 
          />
        ) : (
          <div className="text-center p-4">
            <p className="text-muted">No unverified fields found.</p>
          </div>
        )}
        
        <div className="d-flex justify-content-end">
          <button
            className="btn btn-info mt-2"
            onClick={handleSubmitComment}
            disabled={isSubmitting}
          >
            {isSubmitting ? "Submitting..." : "Submit Comments"}
          </button>
        </div>
            

      </div>:""}

      {/* Pass unverified fields and user role to child component */}
      <SchemesDistrictQuery 
        unverifiedFields={unverifiedFields}
        userRole={userDetail?.Role?.Role_Identifier}
        existData={existData}
       
      
        resubmittedFields={resubmittedFields || { annexureOne:{}, annexureTwo:{}, annexureThree:{} }}
        setResubmittedFields={setResubmittedFields}
      />

        <div className="d-flex justify-center justify-item-center w-100 ">
              {/* {existData?.status === "approvedUnsigned" && (
                <DownloadFormApplication
                  type={type}
                  existData={existData}
                  applicationId={applicationId}
                />
              )} */}
              {existData?.buttonName &&
                existData.buttonName.length > 0 &&
                existData.buttonName[0].appStatusLevel != "schemeGranted" &&
                existData.role !== "" &&
                roleIdentifier === existData.role && (
                  <div className="w-100 d-flex gap-2 flex-column">
                    {!(
                      (["JC"].includes(existData.role) &&
                        existData.appStatusLevel ==
                          "dclerkAfterRejectionAction") ||
                      (["HJC"].includes(existData.role) &&
                        existData.appStatusLevel ==
                          "hoclerkAfterRejectionAction")
                    ) && <div></div>}

                    <div className="d-flex  mb-3 gap-3 justify-content-end me-2">
                      {existData.buttonName &&
                        existData?.buttonName.map((button) => (
                          <button
                            key={button.appStatusLevel}
                            className={`btn ${
                              button.status === "reject"
                                ? "btn-danger"
                                : button.status === "permanentReject"
                                ? "btn-secondary"
                                : "btn-success"
                            }`}
                            onClick={() => {
                              handleFinalSubmit(
                                button.status,
                                button.appStatusLevel
                              );
                            }}
                          >
                            {button.buttonLabel==="Forward to senior clerk for forwarding to Higher Authority"?"Approve":button.buttonLabel}
                          </button>
                        ))}
                    </div>
                  </div>
                )}
            </div>
{/* 
      <div className="d-flex justify-content-end mb-3 me-5">
        {roleIdentifier=="JC" ? <button className="btn btn-info">Submit Again</button>:""}
      </div> */}
    </div>
    <ToastContainer/>
    </>
  );
};

export default SchemesAuthorityDistrictTable;